export const US_STATES = [
    'AL','AK','AZ','AR','CA','CO','CT','DE','FL','GA',
    'HI','ID','IL','IN','IA','KS','KY','LA','ME','MD',
    'MA','MI','MN','MS','MO','MT','NE','NV','NH','NJ',
    'NM','NY','NC','ND','OH','OK','OR','PA','RI','SC',
    'SD','TN','TX','UT','VT','VA','WA','WV','WI','WY'
];

export const PARENT_COMPANIES = [
    'Asbury', 'Sonic', 'AutoNation', 'None of the above'
]

export const BD_OWNER_OPTIONS = [
    'Have not had prior contact', 'Mohamed Desouky', 'Jess Mauro', 'Jean Biele', 'Justin Gervais', 'Mauricio Romero', 'Stefan Williams', 'Worla Flolu', 'Bill Brower', 'Dave Mauger', 'Joe Loudermilk', 'Lindsey Willis'
]

export const DMS = [
    'CDK', 'Dealertrack', 'Reynolds & Reynolds (Ignite)', 'Reynolds & Reynolds (Access)', 'Tekion', 'AutoMate', 'DealerPeak', 'Dealerbuilt', 'PBS', 'Procede', 'Advent', 'Other'
]

export const CRM = [
    'VinSolutions', 'eLeads', 'DriveCentric', 'DealerSocket', 'Tekion', 'DealerPeak', 'Momentum (UDC)', 'PBS', 'Reynolds & Reynolds', 'Other'
]

export const CREDIT_SUBMISSION = [
    'RouteOne', 'Dealertrack', 'Other'
]

export const INVENTORY_SYNDICATION = [
    'vAuto', 'Homenet', 'MAX Digital', 'Vin Cue', 'Other'
]

export const OEM_BRANDS = [
    'Acura',
    'Alfa Romeo',
    'Aston Martin',
    'Audi',
    'Bentley',
    'BMW',
    'Bugatti',
    'Buick',
    'Cadillac',
    'Chevrolet',
    'Chrysler',
    'Dodge',
    'Ferrari',
    'Fiat',
    'Ford',
    'Genesis',
    'GMC',
    'Honda',
    'Hyundai',
    'Infiniti',
    'Isuzu',
    'Jaguar',
    'Jeep',
    'Kia',
    'Lamborghini',
    'Land Rover',
    'Lexus',
    'Lincoln',
    'Lotus',
    'Maserati',
    'Mazda',
    'McLaren',
    'Mercedes',
    'MINI',
    'Mitsubishi',
    'Nissan',
    'Parent Company',
    'Plymouth',
    'Polestar',
    'Porsche',
    'Ram',
    'Rolls-Royce',
    'Saab',
    'Subaru',
    'Tesla',
    'Toyota',
    'Volkswagen',
    'Volvo',
    'Used / Independent'
]

export const DEFAULT_FORM = {
    contact: {
        firstName: '',
        lastName: '',
        title: '',
        email: '',
        phone: '',
        registrationContactEmail: '',
        registrationContactFirstName: '',
        registrationContactLastName: ''
    },
    business: {
        streetAddress: '',
        city: '',
        state: '',
        zipCode: '',
        email: '',
        parentCompany: '',
        name: '',
        phone: '',
        privacyPolicyLink: '',
        websiteLink: '',
        dealerLicenseNumber: '',
        oemDealerId: '',
        brands: [],
        vehicleConditions: [],
        leasing: '',
        groupName: '',
        userInputName: '',
        userInputGroupName: '',
        fordWarrantyOnly: undefined
    },
    software: {
        dmsProvider: '',
        crmProvider: '',
        creditSubmissionProvider: '',
        imsProvider: '',
        dealertrackId: ''
    },
    consentConfirmed: false,
    emailVerified: false,
    bdOwner: ''
}

export const DEFAULT_FORM_ERRORS = {
    stateError: false,
    zipCodeError: false,
    emailError: false,
    phoneError: false,
    businessPhoneError: false,
    businessEmailError: false,
    firstNameError: false,
    lastNameError: false,
    titleError: false,
    streetAddressError: false,
    cityError: false,
    businessNameError: false,
    businessPrivacyPolicyError: false,
    businessWebsiteError: false,
    dealerLicenseError: false,
    oemDealerIdError: false,
    oemBrandError: false,
    vehicleConditionsError: false,
    leasingError: false,
    parentCompanyError: false,
    dmsProviderError: false,
    crmProviderError: false,
    creditSubmissionProviderError: false,
    imsProviderError: false,
    registrationFirstNameError: false,
    registrationLastNameError: false,
    registrationEmailError: false,
    bdOwnerError: false,
    businessGroupNameError: false,
    userInputBusinessNameError: false,
    userInputBusinessGroupNameError: false,
    dealertrackIdError: false,
    fordWarrantyOnlyError: false
}

export const NOT_PROVIDED = 'Not provided';
export const INDEPENDENT_DEALER = 'Independent Dealer'